import React, { useCallback } from 'react'
import Nav from 'react-bootstrap/Nav'

import facebook from './../../facebook.svg'
import linkedin from './../../linkedin.svg'
import shareIcon from './../share.svg'
import twitter from './../../twitter.svg'

import Button from '@/components/button/button'

import * as style from './banner-share.module.scss'

const BannerShare = ({
  isVisible,
  tooltipVisible,
  handleOnShare,
  buttonLink,
  anchor,
  variant = 'static',
  slideIndex
}) => {
  const getHrefBySocial = useCallback((social, i) => {
    if (typeof window === 'undefined') return

    const URL = window.location?.href + '#' + anchor + '?target=' + i

    switch (social) {
      case 'linkedin':
        return 'https://www.linkedin.com/shareArticle?mini=true&url=' + URL
      case 'twitter':
        return 'https://twitter.com/intent/tweet?text=' + URL
      case 'facebook':
        return 'https://www.facebook.com/sharer/sharer.php?u=' + URL
      default:
        break
    }
  }, [])

  return (
    <div
      className={[
        'align-items-center justify-content-between text-base-000',
        style.banner,
        variant === 'fixed' && style.bannerFixed,
        isVisible && style.visible
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <div className={style.wrapperShare}>
        <p className="b100 text-uppercase text-start my-0">
          SHARE THIS INSIGHT
        </p>
        <div className={style.icons}>
          <Nav.Link href={getHrefBySocial('twitter', slideIndex)}>
            <img src={twitter} alt="twitter" />
          </Nav.Link>
          <Nav.Link href={getHrefBySocial('linkedin', slideIndex)}>
            <img src={linkedin} alt="linkedin" />
          </Nav.Link>
          <Nav.Link href={getHrefBySocial('facebook', slideIndex)}>
            <img src={facebook} alt="facebook" />
          </Nav.Link>
          <Nav.Link onClick={handleOnShare}>
            <img src={shareIcon} alt="share" />
          </Nav.Link>
        </div>
      </div>

      {tooltipVisible && (
        <div className={style.tooltip}>
          <span className={`text-start`}>Link copied to clipboard!</span>
        </div>
      )}

      <div className={style.wrapperBtn}>
        <Button
          className={`${style.btn} b300`}
          title="View Full Insights"
          color="custom"
          to={buttonLink}
        />
      </div>
    </div>
  )
}

export default BannerShare
